<ion-card class="app-background">
  <ion-row class="min-height">
    <ion-col
      size="3"
      class="center-item bg-primary text-primary-dark ion-no-padding"
    >
      <ion-icon name="{{ data().icon }}" class="icon-x2"></ion-icon>
    </ion-col>
    <ion-col size="9" class="ion-no-padding ml--1">
      <ion-card-header class="ion-padding ion-text-uppercase">
        <div class="text-grey ion-padding-start title">
          {{ data().label | translate }}
        </div>
        <div class="text-grey ion-padding-start amount">{{ data().count }}</div>
      </ion-card-header>
    </ion-col>
  </ion-row>
</ion-card>
